// Imports
  // Css
  import './css/style.css';
  // React
  import { BrowserRouter, Routes, Route } from 'react-router-dom';
  // Context  
  import { CartContextProvider } from './context/CartContext';
  // Layout
  import Inicio from './layout/Inicio';
  import Productos from './layout/Productos';
  import Combos from './layout/Combos';
  import NotFound from './layout/NotFound';
  // Components
  import NavBar from './components/NavBar';
  import CombosCardDescription from './components/CombosCardDescription';
  import Footer from './components/Footer';
  import Signature from './components/Signature';
  import Cookies from './components/Cookies';
  import WhatsApp from './components/WhatsApp';
  // Admin
  import Admin from './admin/Admin';
  import OrderList from './admin/OrderList';
  import Order from './admin/Order';
  import ItemList from './admin/ItemList';
  import ItemNew from './admin/ItemNew';
  import ItemEdit from './admin/ItemEdit';
  import CombosList from './admin/CombosList';
  import CombosEdit from './admin/CombosEdit';
  import CombosNew from './admin/CombosNew';




//App

function App() {

  return (
    <>
      <div className="App">
        <CartContextProvider>
          <BrowserRouter>
            <header>
              <NavBar />
            </header>
            <main>
              <Routes>
                {/* App */}
                <Route path="/tienda" element={<Inicio />} />
                <Route path="/tienda/productos" element={<Productos />}>
                </Route>
                <Route path="/tienda/combos" element={<Combos />}>
                  <Route path=":id" element={<CombosCardDescription />} />
                </Route>
                {/* Admin */}
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/ordenes" element={<OrderList />} />
                <Route path="/admin/ordenes/:id" element={<Order />} />
                <Route path="/admin/productos" element={<ItemList />} />
                <Route path="/admin/productos/:id" element={<ItemEdit />} />
                <Route path="/admin/productos/nuevo" element={<ItemNew />} />
                <Route path="/admin/combos" element={<CombosList />} />
                <Route path="/admin/combos/:id" element={<CombosEdit />} />
                <Route path="/admin/combos/nuevo" element={<CombosNew />} />
                {/* Not-Found */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <footer>
              <Footer />
              <Signature />
              <WhatsApp />
            </footer>
            <Cookies />
          </BrowserRouter>
        </CartContextProvider>
      </div>
    </>
  );
}

export default App;
